module.exports = __webpack_public_path__ + "static/media/canimolt_INEGI2025_01.09c37ec8.jpg";